const CONTACT_KEY = 'atl-newsletter-contact-v1';
const MAX_AGE = 30 * 60 * 1000;

function status(root, text, error = false) {
  const node = root.querySelector('[data-newsletter-status]');
  if (!node) return;
  node.textContent = text;
  node.hidden = !text;
  node.setAttribute('role', error ? 'alert' : 'status');
}

async function subscribe(root, email, source, consentTime) {
  const response = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(root.dataset.newsletterCompany)}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: '2026-07-15' },
    body: JSON.stringify({ data: {
      type: 'subscription',
      attributes: {
        custom_source: source,
        profile: { data: { type: 'profile', attributes: {
          email,
          subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
          properties: {
            'ATL signup source': source,
            'ATL consent text': root.dataset.newsletterConsent,
            'ATL consent timestamp': consentTime,
            'ATL signup page': window.location.origin + window.location.pathname
          }
        } } }
      },
      relationships: { list: { data: { type: 'list', id: root.dataset.newsletterList } } }
    } }),
    signal: AbortSignal.timeout(15000)
  });
  if (response.status !== 202) throw new Error('Subscription request was not accepted');
}

function initialise() {
  document.querySelectorAll('[data-atl-newsletter-form]').forEach((form) => {
    if (form.dataset.newsletterInitialised) return;
    form.dataset.newsletterInitialised = 'true';
    const controls = form.querySelector('[data-newsletter-controls]');
    controls.disabled = false;
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (form.dataset.busy || !form.reportValidity()) return;
      const email = form.elements.email.value.trim();
      form.dataset.busy = 'true';
      controls.disabled = true;
      status(form, form.dataset.newsletterLoading);
      try {
        await subscribe(form, email, 'ATL footer newsletter', new Date().toISOString());
        status(form, form.dataset.newsletterSuccess);
        form.reset();
      } catch {
        status(form, form.dataset.newsletterError, true);
      } finally {
        controls.disabled = false;
        delete form.dataset.busy;
      }
    });
  });

  document.querySelectorAll('[data-atl-newsletter-contact]').forEach((root) => {
    if (root.dataset.newsletterInitialised) return;
    root.dataset.newsletterInitialised = 'true';
    const form = root.querySelector('.atl-contact-form');
    const choice = root.querySelector('[data-newsletter-choice]');
    let storageAvailable = false;
    try {
      sessionStorage.setItem(`${CONTACT_KEY}-probe`, '1');
      sessionStorage.removeItem(`${CONTACT_KEY}-probe`);
      storageAvailable = true;
    } catch { /* Contact delivery still works when storage is unavailable. */ }
    if (choice && storageAvailable) {
      choice.hidden = false;
      choice.disabled = false;
      // Store intent only. Shopify must confirm contact delivery before signup.
      form.addEventListener('submit', () => {
        try {
          if (form.elements['contact[Newsletter]'].value !== 'Yes') {
            sessionStorage.removeItem(CONTACT_KEY);
            return;
          }
          sessionStorage.setItem(CONTACT_KEY, JSON.stringify({
            email: form.elements['contact[email]'].value.trim(),
            path: location.pathname,
            list: root.dataset.newsletterList,
            company: root.dataset.newsletterCompany,
            time: Date.now()
          }));
        } catch { /* Never prevent the contact form from submitting. */ }
      });
    }
    if (!storageAvailable || !root.querySelector('[data-atl-contact-success]')) return;
    let pending;
    try { pending = JSON.parse(sessionStorage.getItem(CONTACT_KEY)); } catch { return; }
    if (!pending) return;
    if (Date.now() - pending.time > MAX_AGE || pending.time > Date.now()) {
      sessionStorage.removeItem(CONTACT_KEY);
      return;
    }
    if (pending.path !== location.pathname || pending.list !== root.dataset.newsletterList || pending.company !== root.dataset.newsletterCompany) return;
    const retry = root.querySelector('[data-newsletter-retry]');
    async function finish() {
      if (root.dataset.busy) return;
      root.dataset.busy = 'true';
      retry.hidden = true;
      status(root, root.dataset.newsletterLoading);
      try {
        await subscribe(root, pending.email, 'ATL contact form newsletter opt-in', new Date(pending.time).toISOString());
        sessionStorage.removeItem(CONTACT_KEY);
        status(root, root.dataset.newsletterSuccess);
      } catch {
        status(root, root.dataset.newsletterError, true);
        retry.hidden = false;
      } finally {
        delete root.dataset.busy;
      }
    }
    retry.addEventListener('click', finish);
    finish();
  });
}

initialise();
document.addEventListener('shopify:section:load', initialise);
